import { FC, lazy, Suspense } from 'react';
import { ThemeProvider } from '@mui/material';

import {
	CurrentGeoPositionProviderV2,
	NotificationsProvider,
} from '@mopla/business-logic';
import { theme } from '@mopla/mui';
import {
	CrashMessage,
	ErrorBoundary,
	StatusBarStyleSyncProvider,
	useOverlayingWebView,
} from '@mopla/ui';
import { NetworkStatusProvider, shouldEnableDevUtils } from '@mopla/utils';

import { useAnalyticsTracking } from '../app/userTracking/events';
import { environment } from '../environments/environment';

import AppRoutes from './routes/AppRouter';

const FeatureFlagDevHelper = lazy(
	() => import('../components/FeatureFlagDevHelper')
);

const ViewEntrypoint: FC = () => {
	useOverlayingWebView();
	useAnalyticsTracking();

	// Check if dev utilities should be enabled based on environment
	const shouldAddDevUtils = shouldEnableDevUtils(environment.env);

	return (
		<NotificationsProvider>
			<NetworkStatusProvider>
				<>
					{shouldAddDevUtils && (
						<Suspense fallback={null}>
							<FeatureFlagDevHelper />
						</Suspense>
					)}
					<ThemeProvider theme={theme}>
						<ErrorBoundary errorScreen={<CrashMessage />}>
							<StatusBarStyleSyncProvider>
								<CurrentGeoPositionProviderV2>
									<AppRoutes />
								</CurrentGeoPositionProviderV2>
							</StatusBarStyleSyncProvider>
						</ErrorBoundary>
					</ThemeProvider>
				</>
			</NetworkStatusProvider>
		</NotificationsProvider>
	);
};

export default ViewEntrypoint;
